import React from 'react'
import './styles/_spinnerLoading.scss'

export const SpinnerLoading = () => {
  return (
    <div className="loading-container" data-testid="loading-spinner">
      <span className="loading-text" data-testid="loading-text">
        <span className="loading-word">Cargando por favor no cierre la pestaña hasta que el proceso haya finalizado.</span>
        <span className="loader"></span>
      </span>
    </div>
  )
}
